export default __webpack_public_path__ + "static/media/people2.576bbb7e.svg";